import { forwardRef } from 'react';
import { SelectableCard, SelectableCardGroup } from '@gusto/workbench-formik';
import { CardHeader, Grid, Heading } from '@gusto/workbench';

export const NUMBER_EMPLOYEES_SEGMENTATION_KEY = 'NUMBER_EMPLOYEES_SEGMENTATION';

export enum NumberEmployeesSegmentationValues {
  EE_0_2 = '0-2',
  EE_3_9 = '3-9',
  EE_10_24 = '10-24',
  EE_25_99 = '25-99',
  EE_100 = '100+',
}

const NumberEmployeesSegmentation = forwardRef<HTMLFieldSetElement>((_, ref) => {
  return (
    <SelectableCardGroup
      ref={ref}
      className="question"
      name="numberEmployeesSegmentation"
      id="numberEmployeesSegmentation"
      label="How many employees do you have, including yourself?"
      helperText="We support growing businesses at any stage."
    >
      <Grid rowGap={3} columnGap={2} maxWidth={632} maxWidthMd="100%">
        <SelectableCard
          type="radio"
          aria-label="0-2 employees"
          value={NumberEmployeesSegmentationValues.EE_0_2}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              0-2 employees
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="radio"
          aria-label="3-9 employees"
          value={NumberEmployeesSegmentationValues.EE_3_9}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              3-9 employees
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="radio"
          aria-label="10-24 employees"
          value={NumberEmployeesSegmentationValues.EE_10_24}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              10-24 employees
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="radio"
          aria-label="25-99 employees"
          value={NumberEmployeesSegmentationValues.EE_25_99}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              25-99 employees
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="radio"
          aria-label="100+ employees"
          value={NumberEmployeesSegmentationValues.EE_100}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              100+ employees
            </Heading>
          </CardHeader>
        </SelectableCard>
      </Grid>
    </SelectableCardGroup>
  );
});

export default NumberEmployeesSegmentation;
